export default function () {
  return {
    feApps: [],
    entities: [],
    links: [],
    devices: [],
    networkAssets: [],

    selectedFeAppId: null,
    selectedModule: null,
    selectedEntity: null
  }
}
